// พิมพ์ตอนแป้นพิมพ์ยังเป็นภาษาไทย → แปลงกลับเป็นตัวอังกฤษตามปุ่มที่กดจริง (แป้นเกษมณี)
//
// ที่มา (28 ต.ค. 69): user แจ้ง "ใส่ sku แล้ว search ไม่เจอ" — log ของ Supabase 24 ชม. ที่ค้นหน้าสินค้าแล้วได้ 0 แถว
//   เกือบทั้งหมดคือคำอังกฤษที่พิมพ์ตอนแป้นเป็นไทย: "ะฟาริร" = takibi · "ะพีแาพ" = truck… · "พฟรื แ" = rain c ·
//   "ิำำพ" = beer · "สฟืก" = land · "ยำะฟ" = peta · "ัฟำื" = yaen
//   รหัสสินค้ายิ่งหนัก: แถวตัวเลขของแป้นไทยเป็นอักษรไทยด้วย (2 → "/" · 6 → "ุ") พิมพ์รหัสแล้วไม่มีทางเจอ
// ใช้เป็น "คำค้นเพิ่ม" คู่กับคำที่พิมพ์ — คำไทยจริง ("หมวก") ยังค้นได้ตามปกติ

const ROWS = [
  // [ปุ่ม, ตัวไทยที่ได้] — แถวปกติ
  ['1234567890-=', 'ๅ/-ภถุึคตจขช'],
  ['qwertyuiop[]\\', 'ๆไำพะัีรนยบลฃ'],
  ["asdfghjkl;'", 'ฟหกดเ้่าสวง'],
  ['zxcvbnm,./', 'ผปแอิืทมใฝ'],
  // กด shift (ตัวพิมพ์ใหญ่ — ค้นแบบไม่สนตัวพิมพ์อยู่แล้ว)
  ['!@#$%^&*()_+', '+๑๒๓๔ู฿๕๖๗๘๙'],
  ['QWERTYUIOP{}|', '๐"ฎฑธํ๊ณฯญฐ,ฅ'],
  ['ASDFGHJKL:"', 'ฤฆฏโฌ็๋ษศซ.'],
  ['ZXCVBNM<>?', '()ฉฮฺ์?ฒฬฦ'],
];

// ตัวไทย → ปุ่ม · เฉพาะตัวที่ไม่ใช่ตัวอังกฤษ/สัญลักษณ์ที่พิมพ์ได้ทั้งสองแป้น ยกเว้น "/" และ "-"
//   (บนแป้นไทย "/" มาจากปุ่ม 2 และ "-" มาจากปุ่ม 3 — ในข้อความที่มีอักษรไทยปน จึงแปลงกลับเป็นเลข)
const BACK = new Map();
for (const [keys, th] of ROWS) {
  [...th].forEach((ch, i) => {
    if (/[฀-๿]/.test(ch) && !BACK.has(ch)) BACK.set(ch, keys[i]);
  });
}
BACK.set('/', '2');
BACK.set('-', '3');
// กด shift บนแป้นไทยแล้วได้สัญลักษณ์อังกฤษ: W → "  Z → (  X → )  M → ?  (พิมพ์ตัวใหญ่ของรหัสอย่าง TW-470 แล้วค้นไม่เจอ)
BACK.set('"', 'w');
BACK.set('(', 'z');
BACK.set(')', 'x');
BACK.set('?', 'm');

const THAI = /[฀-๿]/;

// คืนคำอังกฤษที่น่าจะตั้งใจพิมพ์ หรือ null ถ้าไม่ใช่กรณีนี้
//   ต้องมีอักษรไทย และแปลงแล้วต้องเป็นตัวอังกฤษ/ตัวเลข/ขีด/เว้นวรรคล้วน — คำไทยจริงอย่าง "หมวก"
//   แปลงแล้วได้ "s,;d" (มีสัญลักษณ์) จึงไม่นับ ไม่ไปค้นมั่ว
export function thaiLayoutToEn(text) {
  const s = String(text ?? '');
  if (!THAI.test(s)) return null;
  const out = [...s].map(ch => BACK.get(ch) ?? ch).join('').toLowerCase();
  if (!/[a-z0-9]/.test(out) || !/^[a-z0-9 \-_.]+$/.test(out)) return null;
  return out;
}
